import { Step } from 'signup-constants/Step';
import { setFlow } from '../../store/flow/action-creators';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getShouldUseBreezeCompanyInfo } from '../../utils/getShouldUseBreezeCompanyInfo';
export const BranchBreezeCompanyInfo = {
  name: 'BranchBreezeCompanyInfo',
  stateCheck: () => {
    return getShouldUseBreezeCompanyInfo();
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postExistingAccountSelection,
      postAccountCreation
    } = getFlowSteps();
    const postVerificationSteps = [Step.Password, Step.Name, Step.CompanyDomain, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.CompanyName];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...postAccountCreation];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreation, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};